import { render, staticRenderFns } from "./generator.vue?vue&type=template&id=2f4d205d&"
import script from "./generator.vue?vue&type=script&lang=js&"
export * from "./generator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports